<template>
  <div class="system-wrap">
    <div class="breadcrumb-wrap clearfix">
      <div class="wrapper">
        <div class="breadcrumb arrow inverted pull-left">
          <div class="start">当前位置：</div>
          <a href="index.html">首页</a>
          <div class="divider">&gt;</div>
          <a href="#">规章制度</a>
        </div>
      </div>
    </div>
    <div class="system-container clearfix">
      <div class="system-content-wrap">
        <ul class="system-box">
          <li class="system-item" v-for="(item,index) in systemDataArr" :key="index">
            <a class="clearfix" :href="item.systemUrl">
              <span class="pull-left icon-box">
                <i class="iconfont icon-wenjian"></i>
              </span>
              <span class="pull-left systemtext">{{ item.systemText }}</span>
              <span class="pull-right">{{ item.systemTime }}</span>
            </a>
          </li>
        </ul>
        <div class="pagination">
          <a class="active" href="#">1</a>
          <a href="#">2</a>
          <a href="#">3</a>
          <a href="#">4</a>
          <a href="#">5</a>
          <a class="btn-next" href="#">下一页&gt;</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import mapChart from "../components/G2charts/map-chart.vue";
// import getpk from '../encrypt/getPassKey' // 获取密码加密函数
// console.log(getpk)
// import api from "../api/index";
export default {
  components: {
    mapChart
  },
  name: "home",
  data() {
    return {
      systemDataArr: [
        {
          systemText: "中华人民共和国律师法的详细解读会议",
          systemTime: "18-11-13",
          systemUrl: "#/detail?&linkIndex=1"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与房地产专业市引发的相业公开征集农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与房地产专业委员会业委员会关于公开征集与房地产专业委员会业委员会关于公与房地产专业委员会业委员会关于公农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与房地产专业委公开征集农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与房地产专业委员会关于公开征农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程开征集农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑集农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与委员会关于公开征地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与房地产专业委员会关于相业委员会关于公开征集农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与房地产专业委员会关于相业委员会关于公开征集农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与房地产专业委员会关于相业委员会关于公开征集农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        },
        {
          systemText:
            "中华全国律师协会建筑工程与房地产专业委员会关于相业委员会关于公开征集农村土地",
          systemTime: "18-11-13",
          systemUrl: "#"
        }
      ]
    };
  },
  methods: {
    ...mapActions([])
  },
  watch: {
    allNumber(newVal) {
      console.log(newVal);
    }
  },
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
@import "../assets/scss/common";
.breadcrumb-wrap {
  padding: 25px 0;
  background-color: $white;
}
.system-wrap {
  width: 100%;
  height: auto;
  background-color: #f8f8f8;
}
.system-container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding: 33px 100px 37px;
}
.system-content-wrap {
  position: relative;
  padding: 50px 40px 100px 40px;
  width: 100%;
  min-height: 770px;
  background-color: $white;
  border-radius: $border-radius;
  .system-box {
    width: 100%;
    height: auto;
    padding: 20px 0 10px;
    .system-item {
      padding: 8px 30px;
      text-align: left;
      font-size: $font-size-lg;
      cursor: pointer;
    }
    .icon-box {
      padding-right: 15px;
    }
    .iconfont {
      line-height: 1;
      font-size: 20px;
    }
    .systemtext {
      width: 610px;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.pagination {
  position: absolute;
  width: 100%;
  height: 33px;
  bottom: 35px;
  left: 0;
  text-align: center;
  a {
    display: inline-block;
    margin: 0 6px;
    width: 33px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    border: 1px solid $home-border;
  }
  .btn-next {
    width: 80px;
  }
}
</style>